import * as React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { getFirstAvailableTopLevelSectionRoute, getTopLevelSectionRoute } from '@/configs/organizationSectionsRouting';
import { buildOrganizationEventsSearch, parseOrganizationViewSearch } from '@/configs/organizationViewSearch';
import { ROUTES } from '@/configs/routes';
import { useOrganizationSectionsStore } from '@/stores/local/shared/OrganizationSectionsStore';
import { useDevices } from '@/utils/devices';

const OrganizationEntryRedirect: React.FC = () => {
  const { id } = useParams();
  const { search } = useLocation();
  const { isCompactViewport } = useDevices();
  const sectionsStore = useOrganizationSectionsStore();

  if (!id) {
    return <Navigate to={ROUTES.root.path} replace />;
  }

  const { isEventsView, eventId } = parseOrganizationViewSearch(search);

  if (isEventsView && sectionsStore.isSectionEnabled('documents')) {
    const base = getTopLevelSectionRoute('documents', id);
    const nextSearch = buildOrganizationEventsSearch(eventId);

    return <Navigate to={`${base}${nextSearch}`} replace />;
  }

  const target =
    getFirstAvailableTopLevelSectionRoute({
      enabledSections: sectionsStore.enabledTopLevelSections,
      organizationId: id,
      isPhone: isCompactViewport,
    }) ?? ROUTES.root.path;

  return <Navigate to={target} replace />;
};

export default React.memo(OrganizationEntryRedirect);
